import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Protocol17025Cat_Interface,Empty_Protocol17025Cat_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Cat_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { Protocol17025CatService } from 'src/app/Service/Protocol17025/Protocol17025Cat.service';

@Component({
  selector: 'app-Protocol17025Cat',
  templateUrl: './Protocol17025Cat.component.html',
  styleUrls: ['./Protocol17025Cat.component.scss']
})
export class Protocol17025CatComponent implements OnInit {
  Procssing:boolean=false


  constructor(
    private Protocol17025Cat_Service:Protocol17025CatService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Protocol17025Cat:Array<Protocol17025Cat_Interface>=[]
  Selected_Protocol17025Cat:Protocol17025Cat_Interface=Empty_Protocol17025Cat_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1171).subscribe(
      data=>{
        this.ReadData_Protocol17025Cat()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Protocol17025Cat(){
    this.Procssing=true
    this.Protocol17025Cat_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Protocol17025Cat=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  //#region Edit

  modalRef_Edit: any;

  OnGet_Edit_Action(template: TemplateRef<any>,item: Protocol17025Cat_Interface) {
    this.Selected_Protocol17025Cat=item
    this.modalRef_Edit = this.modalService.show(template);
  }

  Edit() {
    if (!this.Selected_Protocol17025Cat.title.trim()) {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید.")
    }
    else {
      this.Protocol17025Cat_Service.AddEdit(this.Selected_Protocol17025Cat).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("اطلاعات ویرایش شد")
          this.modalRef_Edit.hide()
        },
        error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

  //#region Add

  modalRef_Add: any;
  Add_Tag_Title: string = ''

  On_Add_Root(template: TemplateRef<any>) {
    this.OnGet_Add_Action(template,Empty_Protocol17025Cat_Interface())
  }

  OnGet_Add_Action(template: TemplateRef<any>,item: Protocol17025Cat_Interface) {
    this.Selected_Protocol17025Cat = item
    this.Add_Tag_Title=""
    this.modalRef_Add = this.modalService.show(template);
  }

  Add(id: number) {

    if (!this.Add_Tag_Title.trim()) {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید.")
    }
    else {

      var temp: Protocol17025Cat_Interface = Empty_Protocol17025Cat_Interface()
      temp.title = this.Add_Tag_Title

      if (id == 0) {
        temp.parent = this.Selected_Protocol17025Cat.id
      }
      else {
        temp.parent = this.Selected_Protocol17025Cat.parent
      }


      this.Protocol17025Cat_Service.AddEdit(temp).subscribe(
        data => {
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده در این سطح تکراری است.")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.ReadData_Protocol17025Cat()
            this.modalRef_Add.hide()
          }
        },
        error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

  //#region Delete

  modalRef_Delete: any;

  OnGet_Remove_Action(template: TemplateRef<any>,item: Protocol17025Cat_Interface) {
    this.Selected_Protocol17025Cat = item
    this.modalRef_Delete = this.modalService.show(template);
  }

  Delete(id: number) {

    this.Protocol17025Cat_Service.Delete(this.Selected_Protocol17025Cat.id,id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات حذف شد")
        this.ReadData_Protocol17025Cat()
        this.modalRef_Delete.hide()
      },
      error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion


}
